import cc from 'classcat';
import Marquee from 'react-fast-marquee';
import { useMemo } from 'react';

import {
  flattenImageAsset,
  selectEntryId,
} from '#src/lib/contentful/selectors.mjs';
import { CloudinaryImage } from '#src/components/CloudinaryImage';
import { From, To } from '#src/components/Responsive';

import styles from './PressLogos.scss';

export function PressLogos({ className, title, logos }) {
  // if the list of logos doesn't occupy the full container width there is a visible gap where the marquee repeats. (This is a dumb hack to make sure it takes up the full width in marquee mode)
  const logosRepeated = useMemo(() => [...logos, ...logos], [logos]);

  return (
    <div className={cc([styles.container, className])}>
      <h2 className={styles.title}>{title}</h2>
      <From slice={2}>
        <div className={styles.logos}>
          {logos.map((logo) => (
            <CloudinaryImage
              key={selectEntryId(logo)}
              {...flattenImageAsset(logo)}
            />
          ))}
        </div>
      </From>
      <To slice={1}>
        <Marquee
          gradientWidth={0}
          className={cc([styles.logos, styles.marquee])}
        >
          {logosRepeated.map((logo, idx) => (
            <CloudinaryImage
              key={selectEntryId(logo) + idx}
              {...flattenImageAsset(logo)}
            />
          ))}
        </Marquee>
      </To>
    </div>
  );
}
